import { setup as setupConfig } from '@cian/config/browser';
import { setup as setupTelemetry } from '@cian/telemetry/browser';
import { setup as setupHttpApi } from '@cian/http-api/browser';
import { UNIQUE_CONFIG_KEY } from '../../shared/constants/config';

import { assertStatusCode } from '../../shared/utils/';

export function setupDependencies() {
  setupConfig({ settingsKey: UNIQUE_CONFIG_KEY });
  setupTelemetry();
  setupHttpApi({
    assertStatusCode,
  });
}
